import { getDrmLicensesUrl, getSsmServerURL } from 'config/api.ts';

export const WIDEVINE_RENEW_ENDPOINT = `${getSsmServerURL()}/renewal-license-wv`;
export const FAIRPLAY_RENEW_ENDPOINT = `${getDrmLicensesUrl()}?renew=true`;
export const SSM_SETUP_ENDPOINT = `${getSsmServerURL()}/sessions/setup`;
export const SSM_TEARDOWN_ENDPOINT = `${getSsmServerURL()}/sessions/teardown`;
export const SSM_HEARTBEAT_ENDPOINT = `${getSsmServerURL()}/sessions/heartbeat`;

export const TOKEN_HEADER_KEY = 'nv-authorizations';
export const SSM_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
};

export const HEARTBEAT_CHECK_INTERVAL = 60000;
export const SSM_SESSION_TOKEN_STORAGE_KEY = 'SSM_SESSION_TOKEN_STORAGE_KEY';

export const SSM_SETUP_FAILED_ERROR_MESSAGE = 'SSM setup failed';
export const SSM_SETUP_NO_CONTENT_TOKEN_PROVIDED_ERROR_MESSAGE =
    'SSM session was not cleaned up or there is no content token provided.';
export const SSM_SETUP_CONCURENCY_ERROR_MESSAGE =
    'Maximum sessions limit reached';
export const SSM_SETUP_INVALID_HEARTBEAT_PERIOD_ERROR_MESSAGE =
    'Invalid heartbeat period';
export const SSM_TEARDOWN_ERROR_MESSAGE = 'There was an error while teardown';
export const SSM_CONTENT_TOKEN_ERROR_MESSAGE =
    'There was an error while retrieving content token';

export const CONCURENCY_NATIVE_ERROR_CODE = 1007;
export const SSM_HEARTBEAT_SEND_MESSAGE_FAILURE = 20;

export const CONCURENCY_ERROR_CODE = 6004;
export const INVALID_HEARTBEAT_PERIOD_ERROR_CODE = 6003;
export const GENERIC_SSM_SETUP_ERROR_CODE = 6001;

export const SSM_CONENTENT_TOKEN_ERROR_403 = 9403;
